import React from 'react';
import {Provider} from "../context/Context";
import Page from "../components/Page";


/**
 *
 */
class PageTemplate extends React.PureComponent {

    render = () => {
        return (
            <Provider router={this.props}>
                <Page/>
            </Provider>
        );
    };
}

export default PageTemplate;